<template>
  <nav class="navbar">
    <div class="logo">
      <a href="https://autileo.pl" title="AUTILEO" class="">
        <img
          :src="require('@/assets/images/autileo.png')"
          alt="Logo"
          height="50px"
          class=""
        />
      </a>
    </div>
    <select v-if="isMobile" v-model="selectedTab" @change="changeTab" class="select-tab-dropdown">
      <option v-for="tab in tabs" :key="tab.name" :value="tab.name">{{ tab.name }}</option>
    </select>

    <ul class="nav-links">
      <li><a href="#observe"><i class="fa fa-dollar"></i> Finansowanie</a></li>
      <li><a href="#observe"><i class="fa fa-insurance"></i> Ubezpieczenia</a></li>
      <li><a href="#observe"><i class="fa fa-heart"></i> Obserwowane</a></li>
      <li v-if="isLoggedIn">
        <div class="dropdown">
          <button class="dropbtn"><i class="fa fa-user"></i> Profil</button>
          <div class="dropdown-content">
            <a href="#settings">Ustawienia</a>
            <a href="#my-ads">Moje ogłoszenia</a>
            <a href="#logout" @click="logout">Wyloguj</a>
          </div>
        </div>
      </li>
      <li v-else>
        <a href="#login">Zaloguj</a>
      </li>
      <!-- <li><a href="#check">Sprawdź auto</a></li> -->
    </ul>
  </nav>
  </template>
  
  <script>
  export default {
    name: 'VehicleSearch',
    data() {
      return {
        username: 'Jan Kowalski', 
        isLoggedIn: true,
        isMobile: false, // Wartość ustawiana na podstawie szerokości ekranu
        selectedTab: 'Osobowe',
        tabs: [
          { name: 'Osobowe', icon: 'fas fa-car' },
          { name: 'Ciężarowe', icon: 'fas fa-truck-moving' },
          { name: 'Dostawcze', icon: 'fas fa-truck' },
          { name: 'Motocykle', icon: 'fas fa-motorcycle' }
        ],
        searchParams: {
          brand: '',
          model: '',
          price: null,
          year: null,
          bodyType: '',
          fuelType: ''
        }
      };
    },
    mounted() {
      this.checkMobile();
      window.addEventListener('resize', this.checkMobile);
    },
    beforeUnmount() {
      window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
      checkMobile() {
        this.isMobile = window.innerWidth < 768;
      },
      changeTab(newTab) {
        this.selectedTab = newTab;
        // Logika do zmiany widoku formularza na podstawie wybranej zakładki
      },
      submitSearch() {
        console.log('Search parameters:', this.searchParams);
      }
    }
  }
  </script>
 <style scoped>
 .navbar {
   display: flex;
   justify-content: space-between;
   align-items: center;
   height: 60px;
   width: 100%;
   background-color: #f8f8f8;
   box-shadow: 0 2px 4px rgba(0,0,0,0.10);
 }
 
 .nav-links {
   display: flex;
   list-style: none;
   margin-right: 50px;
 }
 
 .nav-links li {
   padding: 0 10px;
 }
 
 .nav-links a {
   color: #333;
   text-decoration: none;
 }
 
 .nav-links a:hover {
   color: #555;
   text-decoration: underline;
 }
 
 .dropdown {
   position: relative;
   display: inline-block;
 }
 
 .dropdown-content {
   display: none;
   position: absolute;
   right: 0;
   background-color: #f9f9f9;
   min-width: 160px;
   box-shadow: 0 4px 8px rgba(0,0,0,0.15);
   z-index: 2;
 }
 
 .dropdown-content a {
   color: black;
   padding: 12px 16px;
   text-decoration: none;
   display: block;
 }
 
 .dropdown-content a:hover {
   background-color: #f1f1f1;
 }
 
 .dropdown:hover .dropdown-content {
   display: block;
 }
 
 .dropbtn {
   background: none;
   border: none;
   cursor: pointer;
   font-size: 16px;
   color: #333;
   /* padding: 8px 10px; */
 }
 
 .select-tab-dropdown {
   display: none; /* Tylko na urządzeniach mobilnych */
   width: 100%;
   padding: 8px 10px;
   border: 1px solid #ccc; /* Poprawiono kolor obramowania */
   border-radius: 4px;
   background-color: white;
   color: #333;
   font-size: 16px;
   cursor: pointer;
 }
 
 @media (max-width: 768px) {
   .nav-links > li:not(:last-child) {
     display: none;
   }
 
   .select-tab-dropdown {
     display: block;
   }
 }
 </style>
 